import { useEffect, useState } from "react";
import { Concurrent } from "../../utils/database";
import { concurrentService } from "../../services/concurrentService";
import useToken from "../../../../hooks/auth/useToken";

interface Props {}

export default function useConcurrents({}: Props) {
  const [concurrents, setConcurrents] = useState<Concurrent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();

  const createConcurrent = async (newConcurrent: Concurrent) => {
    try {
      await concurrentService.createConcurrent(token, newConcurrent);
      getConcurrents();
    } catch (error) {
      throw error;
    }
  };

  const getConcurrents = async () => {
    setLoading(true);
    try {
      const concurrentsData = await concurrentService.getConcurrents(token, 100, 0);
      setConcurrents(concurrentsData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setError(error);
      setLoading(false);
    }
  };

  const deleteConcurrent = async (concurrentId: string) => {
    try {
      await concurrentService.deleteConcurrent(token, concurrentId);
      getConcurrents();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  const updateConcurrent = async (updatedConcurrent: Concurrent) => {
    if (!updatedConcurrent.id) {
      alert("Une erreur s'est produite");
      return;
    }
    try {
      await concurrentService.updateConcurrent(token, updatedConcurrent);
      getConcurrents();
    } catch (error) {
      console.error(error);
      setError(error);
    }
  };

  useEffect(() => {
    getConcurrents();
  }, [token]);

  return {
    concurrents,
    getConcurrents,
    length: concurrents.length,
    concurrentsLoading: loading,
    concurrentsError: error,
    deleteConcurrent,
    updateConcurrent,
    createConcurrent,
  };
}
